import Container from '@/ui/_lib/Container';
import { ReactComponent as TextIconLogo } from '@/assets/image/text-icon-logo.svg';
import useAuth from '@/hooks/useAuth';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';

export default function Login() {
  const { useNonAuthenticatedPage, loginWithGoogle } = useAuth();
  const { loginWithRedirect, isAuthenticated, isLoading, user: auth0User } = useAuth0();
  const { logIn } = useAuth();

  useNonAuthenticatedPage();

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated && auth0User && !isLoading) {
      logIn(auth0User);
    }
  }, [isAuthenticated, auth0User, isLoading, logIn]);


  if (isLoading) {
    return (
      <Container className="z-50 flex flex-col items-center justify-center gap-[5rem] bg-[#F8F8FF] bg-opacity-100">
        <div className="flex items-center justify-center h-screen">
          <div>Loading...</div>
        </div>
      </Container>
    );
  }

  return (
    <Container className="z-50 flex flex-col items-center justify-center gap-[5rem] bg-[#F8F8FF] bg-opacity-100 ">
      <div className="heading flex w-full flex-col items-center justify-center gap-2 pt-20 md:flex-row lg:pt-0">
        <TextIconLogo className="w-full" />
      </div>
      <div className="heading flex w-full flex-col items-center justify-center gap-6 md:flex-col lg:pt-0">
        <div className="flex w-full flex-col gap-4 pb-8 sm:pb-0 max-w-sm">
          <button
            onClick={loginWithGoogle}
            className="w-full flex items-center justify-center gap-3 rounded-lg bg-white border border-gray-300 px-4 py-3 text-gray-700 hover:bg-gray-50 transition-colors shadow-sm"
          >
            <svg width="20" height="20" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Continue with Google
          </button>
          
          <button
            onClick={() => loginWithRedirect({
              authorizationParams: {
                connection: 'facebook',
                redirect_uri: window.location.origin,
              },
            })}
            className="w-full flex items-center justify-center gap-3 rounded-lg bg-[#1877F2] px-4 py-3 text-white hover:bg-[#166FE5] transition-colors shadow-sm"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
            Continue with Facebook
          </button>
        </div>
      </div>
    </Container>
  );
}